<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="1300px"
    :innerScroll="false"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
    :loading="loadingButtom"
  >
    <el-form ref="addForm" :model="addForm" :rules="rules" size="small" inline v-loading="loading" class="content">
        <el-form-item label="品类细分:" prop="category">
          <el-select v-model="addForm.category" filterable @change="categoryChange(addForm.category)">
            <el-option v-for="item in categoryList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="大型号:" prop="bigModel">
          <el-select v-model="addForm.bigModel" filterable>
            <el-option v-for="data in bigModelList" :label="data.bigModel" :key="data.bigModel" :value="data.bigModel"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售额差异(万):" prop="saleAmountDiff">
          <el-input v-model="addForm.saleAmountDiff" @input="buyPriceInput('saleAmountDiff')"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input v-model="addForm.remark" type="textarea" :rows="1"></el-input>
        </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
import moment from "moment";
import axios from "@/utils/axiosInstance";
export default {
  name: "CRUDEdit",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "编辑";
    },
  },
  data() {
    return {
      loading: false,
      addForm: {},
      categoryList: [],
      bigModelList: [],
      rules: {
        category: [{ required: true, message: "不能为空", trigger: "change" }],
        bigModel: [{ required: true, message: "不能为空", trigger: "change" }],
        saleAmountDiff: [{ required: true, message: "不能为空", trigger: "bu" }],
        // remark: [{ required: true, message: "不能为空", trigger: "change" }],
      },
      loadingButtom: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        this.$q.product
          .categoryBigModelConfigUpdate({ data: this.addForm })
          .then((res) => {
            if (res.code == 200) {
              let text = this.title + "成功";
              this.$message.success(text);
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
    getOptionTypes() {
      this.loading = true
      this.$q.product.optionTypes().then((res) => {
        this.categoryList = res.data.categoryList;
      }).finally(_=>{
        this.loading = false
      });
    },
    categoryChange(val,type) {
      if(!type) {
        this.$set(this.addForm,'bigModel','')
      }
      let data = { ...this.currencyForm };
      data.reportCode = "searchBigModelByCategory";
      data.param = {
        category: val,
      };
      axios.post(`/ec-pc-api/custom/reports/data/searchBigModelByCategory`, data).then((res) => {
        if (res.code == 200) {
          this.bigModelList = res.data.list
        }
      });
    },
    //只能输入正数并小数点保留两位
    buyPriceInput(name) {
      var price = "" + this.addForm[name];
      this.addForm.updateList[index][name] = price.match(/^\d*(\.?\d{0,2})/g)[0];
    },
  },
  created() {
    this.addForm = this.rowData
    this.categoryChange(this.addForm.category,true)
    this.getOptionTypes();
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-date-editor, >>> .el-select, >>> .el-input {
  width: 170px !important;
}
// .content {
//   max-height: 70vh
//   overflow-y: auto
//   text-align: center
// }

</style>
